export const SoldDataTableCustomColumnKey = {
  Address: 'address',
  Transactions: 'transactions',
  City: 'city',
  Year: 'year',
  Month: 'month',
  ListPrice: 'listPrice',
  SoldPrice: 'soldPrice',
  SoldListRatio: 'soldListRatio',
  BuildingType: 'buildingType',
  BuildingTypes: 'buildingTypes',
  FinishedSqft: 'finishedSqft',
  Beds: 'beds',
  TotalBeds: 'totalBeds',
  Baths: 'fullBaths',
  Visibility: 'visibility',
};

export const SoldDataTableEventType = {
  PaginationChange: 'pagination-change',
  ToggleVisibility: 'toggle-visibility',
  TransactionChange: 'transaction-change',
};
